import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { SearchIcon, FilterIcon, CheckCircleIcon, ClockIcon, AlertCircleIcon, FileTextIcon, ShieldIcon, BookOpenIcon, ChevronDownIcon, ChevronUpIcon, InfoIcon, CheckIcon, XIcon } from 'lucide-react';
import Card from '../components/Card';
import Button from '../components/Button';
const ShariahCompliance = () => {
  const [activeTab, setActiveTab] = useState('pending');
  const [searchQuery, setSearchQuery] = useState('');
  const [expandedApplication, setExpandedApplication] = useState<string | null>(null);
  const toggleApplicationDetails = (id: string) => {
    if (expandedApplication === id) {
      setExpandedApplication(null);
    } else {
      setExpandedApplication(id);
    }
  };
  return <div className="max-w-6xl mx-auto" data-id="element-3080">
      <div className="mb-6" data-id="element-3081">
        <h1 className="text-2xl font-bold text-secondary mb-2" data-id="element-3082">
          Shariah Compliance Module
        </h1>
        <p className="text-neutral-400" data-id="element-3083">
          Review and validate sukuk structures for Shariah compliance
        </p>
      </div>
      {/* Dashboard Overview */}
      <section className="mb-8" data-id="element-3084">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-3085">
          <Card data-id="element-3086">
            <div className="flex items-center mb-2" data-id="element-3087">
              <div className="w-10 h-10 rounded-full bg-warning bg-opacity-10 flex items-center justify-center mr-3" data-id="element-3088">
                <ClockIcon className="w-5 h-5 text-warning" data-id="element-3089" />
              </div>
              <div data-id="element-3090">
                <h3 className="font-medium" data-id="element-3091">Pending Reviews</h3>
              </div>
            </div>
            <div className="text-2xl font-bold" data-id="element-3092">5</div>
            <div className="text-xs text-neutral-400 mt-1" data-id="element-3093">
              Estimated: 3 hours
            </div>
          </Card>
          <Card data-id="element-3094">
            <div className="flex items-center mb-2" data-id="element-3095">
              <div className="w-10 h-10 rounded-full bg-success bg-opacity-10 flex items-center justify-center mr-3" data-id="element-3096">
                <CheckCircleIcon className="w-5 h-5 text-success" data-id="element-3097" />
              </div>
              <div data-id="element-3098">
                <h3 className="font-medium" data-id="element-3099">Approved This Week</h3>
              </div>
            </div>
            <div className="text-2xl font-bold" data-id="element-3100">12</div>
            <div className="text-xs text-neutral-400 mt-1" data-id="element-3101">
              Total value: RM 580,000
            </div>
          </Card>
          <Card data-id="element-3102">
            <div className="flex items-center mb-2" data-id="element-3103">
              <div className="w-10 h-10 rounded-full bg-error bg-opacity-10 flex items-center justify-center mr-3" data-id="element-3104">
                <AlertCircleIcon className="w-5 h-5 text-error" data-id="element-3105" />
              </div>
              <div data-id="element-3106">
                <h3 className="font-medium" data-id="element-3107">Requires Revision</h3>
              </div>
            </div>
            <div className="text-2xl font-bold" data-id="element-3108">2</div>
            <div className="text-xs text-neutral-400 mt-1" data-id="element-3109">
              Awaiting amendments
            </div>
          </Card>
        </div>
      </section>
      {/* Application Management */}
      <section className="mb-8" data-id="element-3110">
        <Card data-id="element-3111">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6" data-id="element-3112">
            <h2 className="text-xl font-bold" data-id="element-3113">Micro-Sukuk Applications</h2>
            <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-2 mt-3 md:mt-0 w-full md:w-auto" data-id="element-3114">
              <div className="relative" data-id="element-3115">
                <input type="text" placeholder="Search applications..." className="pl-9 pr-4 py-2 border border-neutral-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary w-full md:w-auto" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-3116" />
                <SearchIcon className="w-4 h-4 absolute left-3 top-3 text-neutral-400" data-id="element-3117" />
              </div>
              <Button variant="outline" icon={<FilterIcon className="w-4 h-4" data-id="element-3119" />} iconPosition="left" data-id="element-3118">
                Filter
              </Button>
            </div>
          </div>
          {/* Tabs */}
          <div className="mb-4 border-b border-neutral-200" data-id="element-3120">
            <div className="flex overflow-x-auto -mb-px" data-id="element-3121">
              <button className={`py-2 px-4 font-medium text-sm whitespace-nowrap ${activeTab === 'pending' ? 'border-b-2 border-primary text-primary' : 'text-neutral-400 hover:text-neutral-600'}`} onClick={() => setActiveTab('pending')} data-id="element-3122">
                Pending Review (5)
              </button>
              <button className={`py-2 px-4 font-medium text-sm whitespace-nowrap ${activeTab === 'approved' ? 'border-b-2 border-primary text-primary' : 'text-neutral-400 hover:text-neutral-600'}`} onClick={() => setActiveTab('approved')} data-id="element-3123">
                Approved (12)
              </button>
              <button className={`py-2 px-4 font-medium text-sm whitespace-nowrap ${activeTab === 'revision' ? 'border-b-2 border-primary text-primary' : 'text-neutral-400 hover:text-neutral-600'}`} onClick={() => setActiveTab('revision')} data-id="element-3124">
                Requires Revision (2)
              </button>
              <button className={`py-2 px-4 font-medium text-sm whitespace-nowrap ${activeTab === 'all' ? 'border-b-2 border-primary text-primary' : 'text-neutral-400 hover:text-neutral-600'}`} onClick={() => setActiveTab('all')} data-id="element-3125">
                All Applications
              </button>
            </div>
          </div>
          {/* Applications Table */}
          <div className="overflow-x-auto" data-id="element-3126">
            <table className="w-full" data-id="element-3127">
              <thead data-id="element-3128">
                <tr className="text-left border-b border-neutral-100" data-id="element-3129">
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-3130">ID</th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-3131">
                    Business
                  </th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-3132">
                    Structure Type
                  </th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-3133">Amount</th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-3134">
                    Submitted
                  </th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-3135">
                    Priority
                  </th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-3136">Actions</th>
                </tr>
              </thead>
              <tbody data-id="element-3137">
                <tr className="border-b border-neutral-100" data-id="element-3138">
                  <td className="py-3" data-id="element-3139">#SR1045</td>
                  <td className="py-3" data-id="element-3140">GreenTech Solutions</td>
                  <td className="py-3" data-id="element-3141">Inventory Financing</td>
                  <td className="py-3" data-id="element-3142">RM 50,000</td>
                  <td className="py-3" data-id="element-3143">2 days ago</td>
                  <td className="py-3" data-id="element-3144">
                    <span className="bg-error bg-opacity-10 text-error px-2 py-1 rounded-full text-xs font-medium" data-id="element-3145">
                      High
                    </span>
                  </td>
                  <td className="py-3" data-id="element-3146">
                    <Link to="/dashboard/shariah-review/1045" data-id="element-3147">
                      <Button variant="primary" size="sm" data-id="element-3148">
                        Review
                      </Button>
                    </Link>
                  </td>
                </tr>
                <tr className="border-b border-neutral-100 cursor-pointer hover:bg-neutral-50" onClick={() => toggleApplicationDetails('SR1046')} data-id="element-3149">
                  <td className="py-3" data-id="element-3150">#SR1046</td>
                  <td className="py-3" data-id="element-3151">Amani Cafe</td>
                  <td className="py-3" data-id="element-3152">Equipment Financing</td>
                  <td className="py-3" data-id="element-3153">RM 25,000</td>
                  <td className="py-3" data-id="element-3154">1 day ago</td>
                  <td className="py-3" data-id="element-3155">
                    <span className="bg-warning bg-opacity-10 text-warning px-2 py-1 rounded-full text-xs font-medium" data-id="element-3156">
                      Medium
                    </span>
                  </td>
                  <td className="py-3" data-id="element-3157">
                    <div className="flex items-center" data-id="element-3158">
                      <Link to="/dashboard/shariah-review/1046" data-id="element-3159">
                        <Button variant="primary" size="sm" className="mr-2" data-id="element-3160">
                          Review
                        </Button>
                      </Link>
                      {expandedApplication === 'SR1046' ? <ChevronUpIcon className="w-5 h-5 text-neutral-400" data-id="element-3161" /> : <ChevronDownIcon className="w-5 h-5 text-neutral-400" data-id="element-3162" />}
                    </div>
                  </td>
                </tr>
                {expandedApplication === 'SR1046' && <tr className="bg-neutral-50" data-id="element-3163">
                    <td colSpan={7} className="py-4 px-4" data-id="element-3164">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3165">
                        <div data-id="element-3166">
                          <h4 className="font-medium mb-3" data-id="element-3167">
                            Application Details
                          </h4>
                          <div className="space-y-3" data-id="element-3168">
                            <div className="flex justify-between" data-id="element-3169">
                              <span className="text-sm text-neutral-400" data-id="element-3170">
                                Rating
                              </span>
                              <span className="text-sm font-medium text-success" data-id="element-3171">
                                Low Risk (A)
                              </span>
                            </div>
                            <div className="flex justify-between" data-id="element-3172">
                              <span className="text-sm text-neutral-400" data-id="element-3173">
                                Profit Rate
                              </span>
                              <span className="text-sm font-medium" data-id="element-3174">
                                12% p.a.
                              </span>
                            </div>
                            <div className="flex justify-between" data-id="element-3175">
                              <span className="text-sm text-neutral-400" data-id="element-3176">
                                Duration
                              </span>
                              <span className="text-sm font-medium" data-id="element-3177">
                                6 months
                              </span>
                            </div>
                            <div className="flex justify-between" data-id="element-3178">
                              <span className="text-sm text-neutral-400" data-id="element-3179">
                                Contract Type
                              </span>
                              <span className="text-sm font-medium" data-id="element-3180">
                                Ijarah (Leasing)
                              </span>
                            </div>
                          </div>
                        </div>
                        <div data-id="element-3181">
                          <h4 className="font-medium mb-3" data-id="element-3182">
                            Rating Agency Notes
                          </h4>
                          <div className="bg-neutral-100 p-3 rounded-lg text-sm mb-3" data-id="element-3183">
                            <p data-id="element-3184">
                              Amani Cafe demonstrates strong financial
                              performance with a healthy profit margin of 28.9%
                              and low debt-to-income ratio of 17.3%. The
                              business has been operating for over 3 years with
                              consistent growth.
                            </p>
                          </div>
                          <Link to="/dashboard/shariah-review/1046" data-id="element-3185">
                            <Button variant="primary" size="sm" data-id="element-3186">
                              Begin Detailed Review
                            </Button>
                          </Link>
                        </div>
                      </div>
                    </td>
                  </tr>}
                <tr className="border-b border-neutral-100" data-id="element-3187">
                  <td className="py-3" data-id="element-3188">#SR1047</td>
                  <td className="py-3" data-id="element-3189">Modest Fashion House</td>
                  <td className="py-3" data-id="element-3190">Expansion Financing</td>
                  <td className="py-3" data-id="element-3191">RM 80,000</td>
                  <td className="py-3" data-id="element-3192">6 hours ago</td>
                  <td className="py-3" data-id="element-3193">
                    <span className="bg-warning bg-opacity-10 text-warning px-2 py-1 rounded-full text-xs font-medium" data-id="element-3194">
                      Medium
                    </span>
                  </td>
                  <td className="py-3" data-id="element-3195">
                    <Link to="/dashboard/shariah-review/1047" data-id="element-3196">
                      <Button variant="primary" size="sm" data-id="element-3197">
                        Review
                      </Button>
                    </Link>
                  </td>
                </tr>
                <tr className="border-b border-neutral-100" data-id="element-3198">
                  <td className="py-3" data-id="element-3199">#SR1048</td>
                  <td className="py-3" data-id="element-3200">Halal Delights</td>
                  <td className="py-3" data-id="element-3201">Working Capital</td>
                  <td className="py-3" data-id="element-3202">RM 35,000</td>
                  <td className="py-3" data-id="element-3203">3 hours ago</td>
                  <td className="py-3" data-id="element-3204">
                    <span className="bg-success bg-opacity-10 text-success px-2 py-1 rounded-full text-xs font-medium" data-id="element-3205">
                      Low
                    </span>
                  </td>
                  <td className="py-3" data-id="element-3206">
                    <Link to="/dashboard/shariah-review/1048" data-id="element-3207">
                      <Button variant="primary" size="sm" data-id="element-3208">
                        Review
                      </Button>
                    </Link>
                  </td>
                </tr>
                <tr className="border-b border-neutral-100" data-id="element-3209">
                  <td className="py-3" data-id="element-3210">#SR1049</td>
                  <td className="py-3" data-id="element-3211">Tech Innovate</td>
                  <td className="py-3" data-id="element-3212">Equipment Financing</td>
                  <td className="py-3" data-id="element-3213">RM 60,000</td>
                  <td className="py-3" data-id="element-3214">1 hour ago</td>
                  <td className="py-3" data-id="element-3215">
                    <span className="bg-warning bg-opacity-10 text-warning px-2 py-1 rounded-full text-xs font-medium" data-id="element-3216">
                      Medium
                    </span>
                  </td>
                  <td className="py-3" data-id="element-3217">
                    <Link to="/dashboard/shariah-review/1049" data-id="element-3218">
                      <Button variant="primary" size="sm" data-id="element-3219">
                        Review
                      </Button>
                    </Link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Card>
      </section>
      {/* Shariah Compliance Guidelines */}
      <section className="mb-8" data-id="element-3220">
        <h2 className="text-xl font-bold mb-4" data-id="element-3221">
          Shariah Compliance Guidelines
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3222">
          <Card data-id="element-3223">
            <div className="flex items-center mb-4" data-id="element-3224">
              <div className="w-10 h-10 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mr-3" data-id="element-3225">
                <BookOpenIcon className="w-5 h-5 text-secondary" data-id="element-3226" />
              </div>
              <h3 className="font-medium" data-id="element-3227">Contract Structures</h3>
            </div>
            <div className="space-y-3 mb-4" data-id="element-3228">
              <div className="flex items-start" data-id="element-3229">
                <div className="w-6 h-6 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mr-2 flex-shrink-0 mt-0.5" data-id="element-3230">
                  <CheckIcon className="w-3 h-3 text-secondary" data-id="element-3231" />
                </div>
                <div data-id="element-3232">
                  <div className="font-medium" data-id="element-3233">Ijarah (Leasing)</div>
                  <p className="text-sm text-neutral-400" data-id="element-3234">
                    For equipment and asset financing. Ensure the asset is
                    clearly identified and ownership transfer is properly
                    structured.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-3235">
                <div className="w-6 h-6 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mr-2 flex-shrink-0 mt-0.5" data-id="element-3236">
                  <CheckIcon className="w-3 h-3 text-secondary" data-id="element-3237" />
                </div>
                <div data-id="element-3238">
                  <div className="font-medium" data-id="element-3239">Murabahah (Cost-Plus Sale)</div>
                  <p className="text-sm text-neutral-400" data-id="element-3240">
                    For inventory financing. Ensure cost and markup are clearly
                    disclosed and the asset changes ownership.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-3241">
                <div className="w-6 h-6 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mr-2 flex-shrink-0 mt-0.5" data-id="element-3242">
                  <CheckIcon className="w-3 h-3 text-secondary" data-id="element-3243" />
                </div>
                <div data-id="element-3244">
                  <div className="font-medium" data-id="element-3245">Musharakah (Partnership)</div>
                  <p className="text-sm text-neutral-400" data-id="element-3246">
                    For business expansion. Verify profit-sharing ratios and
                    management responsibilities.
                  </p>
                </div>
              </div>
            </div>
            <Button variant="outline" className="border-secondary text-secondary" size="sm" data-id="element-3247">
              View Full Guidelines
            </Button>
          </Card>
          <Card data-id="element-3248">
            <div className="flex items-center mb-4" data-id="element-3249">
              <div className="w-10 h-10 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mr-3" data-id="element-3250">
                <ShieldIcon className="w-5 h-5 text-secondary" data-id="element-3251" />
              </div>
              <h3 className="font-medium" data-id="element-3252">Compliance Checklist</h3>
            </div>
            <div className="space-y-3 mb-4" data-id="element-3253">
              <div className="flex items-center" data-id="element-3254">
                <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-3255" />
                <span className="text-sm" data-id="element-3256">Free from interest (riba)</span>
              </div>
              <div className="flex items-center" data-id="element-3257">
                <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-3258" />
                <span className="text-sm" data-id="element-3259">
                  Free from excessive uncertainty (gharar)
                </span>
              </div>
              <div className="flex items-center" data-id="element-3260">
                <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-3261" />
                <span className="text-sm" data-id="element-3262">
                  Free from gambling elements (maysir)
                </span>
              </div>
              <div className="flex items-center" data-id="element-3263">
                <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-3264" />
                <span className="text-sm" data-id="element-3265">Underlying assets are halal</span>
              </div>
              <div className="flex items-center" data-id="element-3266">
                <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-3267" />
                <span className="text-sm" data-id="element-3268">
                  Clear ownership and transfer mechanisms
                </span>
              </div>
              <div className="flex items-center" data-id="element-3269">
                <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-3270" />
                <span className="text-sm" data-id="element-3271">
                  Risk and reward sharing is equitable
                </span>
              </div>
            </div>
            <div className="bg-secondary bg-opacity-5 border border-secondary border-opacity-20 rounded-lg p-4" data-id="element-3272">
              <div className="flex items-center mb-2" data-id="element-3273">
                <InfoIcon className="w-5 h-5 text-secondary mr-2" data-id="element-3274" />
                <h4 className="font-medium text-secondary" data-id="element-3275">Reminder</h4>
              </div>
              <p className="text-sm text-neutral-500" data-id="element-3276">
                All micro-sukuk structures must be reviewed within 48 hours of
                submission to ensure timely processing for MSMEs.
              </p>
            </div>
          </Card>
        </div>
      </section>
    </div>;
};
export default ShariahCompliance;